import { render, staticRenderFns } from "./BasePost.vue?vue&type=template&id=3de77179&scoped=true&"
import script from "./BasePost.vue?vue&type=script&lang=js&"
export * from "./BasePost.vue?vue&type=script&lang=js&"
import style0 from "./BasePost.vue?vue&type=style&index=0&id=3de77179&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de77179",
  null
  
)

export default component.exports